export const AssetSubCategoryValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    if (!formData.AssetCategoryID===0) {
      errors.AssetCategoryID = 'Asset Category is required';
    } 
    if (!formData.SubCategoryName.trim()) {
        errors.SubCategoryName = 'Sub Category is required';
    }
    if (!formData.dec_DepRate.trim()) {
        errors.dec_DepRate = 'Dep Rate is required';
    } 
  
    return errors;
  };
  
 